<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <app-page-container v-else>
      <template v-if="table_hotels.length">
        <AppAccHotel
          v-for="(item, index) in table_hotels"
          :key="`hotel_acc_${item.id}`"
          :reservation="item.reservation"
          :order-number="index + 1"
        />
        <app-cells :position="pagination_hotels.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickHotelsPagination"
            v-if="pagination_hotels.pages > 1"
            v-model="pagination_hotels.page"
            :page-count="pagination_hotels.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records
            :all="pagination_hotels.count"
            :count="table_hotels.length"
            :page="pagination_hotels.page"
            :limit="40"
          />
        </app-cells>
      </template>
      <app-no-results v-if="!table_hotels.length" text="There’s no reservations yet" />
    </app-page-container>
  </div>
</template>

<script>
import { getReservationsHotelAmendmentRequests } from '@/http'
import AppAccHotel from '@/components/AppAccHotel.vue'

export default {
  name: 'HotelsAmendmentsCancelled',
  components: { AppAccHotel },
  data() {
    return {
      is_loaded: false,
      table_hotels: [],
      pagination_hotels: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    getReservationsHotelAmendmentRequests({ page: this.pagination_hotels.page, page_size: 40, reservation_status__complete: true })
      .then(res => {
        this.table_hotels = res.data.results
        this.pagination_hotels.pages = res.data.pages
        this.pagination_hotels.count = res.data.count

        this.is_loaded = true
      })
  },
  methods: {
    fetchHotelsItems() {
      getReservationsHotelAmendmentRequests({
        page: this.pagination_hotels.page,
        page_size: 40,
        reservation_status__complete: true
      })
        .then(res => {
          this.table_hotels = res.data.results
          this.pagination_hotels.pages = res.data.pages
          this.pagination_hotels.count = res.data.count
        })
    },
    onClickHotelsPagination(page) {
      this.pagination_hotels.page = page
      this.fetchHotelsItems()
    },
  }
}
</script>
